import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
import NotFound404Exception from "@/exceptions/NotFound404Exception";
import InternalServerError500Exception from "@/exceptions/InternalServerError500Exception";
import { apiUrl } from "@globalConfig";
import { mapSelected } from "@/pages/search/searchHooks/utils";
import { handleFilter, mapFacets } from "@/apis/search/searchUtils";
import { _checkABFlag } from "@hooks/useCheckABFlag";
import useLocalStorage from "@hooks/useLocalStorage";
import useCookieClient from "@hooks/useCookieClient";
import { SEARCH_LAB_ENABLED } from "@globalConfig";
import { searchLab__doSearch, searchLab__doSearch_with_params, searchLab__autosuggest } from "@/apis/searchLab/searchLab";
var pendingRequests = {};
var ABTestSearchResults = function ABTestSearchResults(size, page) {
  return function (searchResults) {
    var _useLocalStorage = useLocalStorage(false),
      getLocalStorage = _useLocalStorage.getLocalStorage;
    var _useCookieClient = useCookieClient(),
      getCookieClient = _useCookieClient.getCookieClient;
    var AB_SHOW_FINANCE_ELIGIBILITY = _checkABFlag("AB_SHOW_FINANCE_ELIGIBILITY", getCookieClient, getLocalStorage);
    if (AB_SHOW_FINANCE_ELIGIBILITY) {
      var newProducts = [];

      // Calculate absolute position for current page
      var startIndex = (page - 1) * size; // Changed from page * size

      searchResults.products.forEach(function (product, idx) {
        var absolutePosition = startIndex + idx;

        // Add card after position 3 or every 12 positions after 15
        if ((absolutePosition - 3) % 12 === 0 && absolutePosition >= 3) {
          newProducts.push({
            isEligibilityCard: true
          });
        }
        newProducts.push(product);
      });
      searchResults.products = newProducts;
    }
    return searchResults;
  };
};
export function fetchSearchResults(_x, _x2) {
  return _fetchSearchResults.apply(this, arguments);
}
function _fetchSearchResults() {
  _fetchSearchResults = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(req, axiosConfig) {
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          return _context5.a(2, fetcher(req).get("/search/index", axiosConfig).then(/*#__PURE__*/function () {
            var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(res) {
              var _res$data2, _req$query2, _res$data3;
              return _regenerator().w(function (_context4) {
                while (1) switch (_context4.n) {
                  case 0:
                    if (!((res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.code) !== 200)) {
                      _context4.n = 1;
                      break;
                    }
                    throw new InternalServerError500Exception("api__doSearch", {
                      url: "search/index",
                      data: axiosConfig.params
                    });
                  case 1:
                    if (!(req !== null && req !== void 0 && (_req$query2 = req.query) !== null && _req$query2 !== void 0 && _req$query2.page && +req.query.page > res.data.data.total_pages)) {
                      _context4.n = 2;
                      break;
                    }
                    throw new NotFound404Exception("api__doSearch_page_exceeds_total_pages");
                  case 2:
                    return _context4.a(2, (res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.data) || {});
                }
              }, _callee4);
            }));
            return function (_x7) {
              return _ref5.apply(this, arguments);
            };
          }()));
      }
    }, _callee5);
  }));
  return _fetchSearchResults.apply(this, arguments);
}
export var api__doSearch_with_params = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var req, _ref$page, page, filters, _ref$sort, sort, _ref$link, link, _ref$size, size, includes, data, searchResults;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          req = _ref.req, _ref$page = _ref.page, page = _ref$page === void 0 ? 1 : _ref$page, filters = _ref.filters, _ref$sort = _ref.sort, sort = _ref$sort === void 0 ? "" : _ref$sort, _ref$link = _ref.link, link = _ref$link === void 0 ? "" : _ref$link, _ref$size = _ref.size, size = _ref$size === void 0 ? 15 : _ref$size, includes = _ref.includes;
          if (!SEARCH_LAB_ENABLED) {
            _context.n = 1;
            break;
          }
          return _context.a(2, searchLab__doSearch_with_params({
            req: req,
            page: page,
            filters: filters,
            sort: sort,
            link: link,
            size: size,
            includes: includes
          }));
        case 1:
          filters = handleFilter(filters);
          data = {
            filters: filters,
            link: link,
            page: page,
            sort: sort || "",
            size: size,
            new_path: !!(link !== null && link !== void 0 && link.includes("/autos") || link !== null && link !== void 0 && link.includes("/years") || link !== null && link !== void 0 && link.includes("/car-countries"))
          };
          _context.n = 2;
          return api__doSearch(req, page, data, includes).then(ABTestSearchResults(size, page));
        case 2:
          searchResults = _context.v;
          return _context.a(2, {
            posts: searchResults.products,
            filters: mapFacets(searchResults.facets) || [],
            sortOptions: searchResults.sort_options,
            marketingBanner: {
              desktop: searchResults.marketing_banner_desktop,
              mobile: searchResults.marketing_banner_mobile
            },
            similarItems: searchResults.similar_items,
            dealFacet: searchResults.deal,
            specs: searchResults.specs,
            selectedOptions: mapSelected(searchResults.selected),
            //
            metaData: {
              seoData: searchResults.seo_data,
              totalPages: searchResults.total_pages,
              title: searchResults.title,
              currentPage: Math.min(searchResults.total_pages, searchResults.page),
              productsCount: searchResults.products_count,
              category_path: searchResults.category_path,
              request_id: searchResults.request_id,
              metaTags: searchResults.meta_tags
            },
            search_meta: searchResults.search_meta
          });
      }
    }, _callee);
  }));
  return function api__doSearch_with_params(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var api__doSearch = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(req) {
    var _req$query;
    var page,
      data,
      includes,
      requestData,
      cacheKey,
      axiosConfig,
      requestPromise,
      _args2 = arguments;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          page = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 1;
          data = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
          includes = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : [];
          if (!(req !== null && req !== void 0 && (_req$query = req.query) !== null && _req$query !== void 0 && _req$query.page && (+req.query.page < 1 || isNaN(+req.query.page)))) {
            _context2.n = 1;
            break;
          }
          throw new NotFound404Exception("api__doSearch_wrong_validation");
        case 1:
          if (!SEARCH_LAB_ENABLED) {
            _context2.n = 2;
            break;
          }
          return _context2.a(2, searchLab__doSearch(req, page, data, includes));
        case 2:
          requestData = {
            ps: "".concat(page, "-").concat(data === null || data === void 0 ? void 0 : data.size),
            includes: includes.join(","),
            search_data: JSON.stringify(data || {})
          };
          cacheKey = JSON.stringify(requestData);
          if (!(__IS_CSR__ && pendingRequests[cacheKey])) {
            _context2.n = 4;
            break;
          }
          _context2.n = 3;
          return pendingRequests[cacheKey];
        case 3:
          return _context2.a(2, _context2.v);
        case 4:
          axiosConfig = {
            params: requestData
          };
          requestPromise = fetchSearchResults(req, axiosConfig)["finally"](function () {
            if (__IS_CSR__) {
              delete pendingRequests[cacheKey];
            }
          });
          if (__IS_CSR__) {
            pendingRequests[cacheKey] = requestPromise;
          }
          _context2.n = 5;
          return requestPromise;
        case 5:
          return _context2.a(2, _context2.v);
      }
    }, _callee2);
  }));
  return function api__doSearch(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
export var api__getUnbxdSuggestions = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(lang, searchTerm) {
    var _res$data, _res$data$data;
    var normalizedSearchTerm, url, res;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          normalizedSearchTerm = searchTerm || "";
          if (!SEARCH_LAB_ENABLED) {
            _context3.n = 1;
            break;
          }
          return _context3.a(2, searchLab__autosuggest(null, normalizedSearchTerm));
        case 1:
          url = (process.env.RAZZLE_ENV_UNBXD_AUTOSUGGEST_URL || "").replace("{lang}", lang).replace("{apiUrl}", apiUrl);
          _context3.n = 2;
          return fetcher().get("".concat(url).concat(normalizedSearchTerm));
        case 2:
          res = _context3.v;
          return _context3.a(2, ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$data = _res$data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.products) || []);
      }
    }, _callee3);
  }));
  return function api__getUnbxdSuggestions(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();